import React from 'react';
import PropTypes from 'prop-types';

import sumBy from 'lodash/sumBy';

import { LocaleService } from '@sm360/widget-commons-core-services';

import TransactionProgressBar from 'login/components/Transaction/TransactionProgressBar/TransactionProgressBar.jsx';
import TransactionTimeSaved from 'login/components/Transaction/TransactionTimeSaved/TransactionTimeSaved.jsx';
import TRANSACTION from 'login/constants/transaction.js';

import 'login/components/Transaction/TransactionProgression/TransactionProgression.scss';

const MAX_TIME = sumBy(Object.keys(TRANSACTION).map((value) => TRANSACTION[value]), 'timeSaved');

function getpercentageProgression(effectiveTimeSavedSeconds, maxTimeSavedSeconds) {
    if (!maxTimeSavedSeconds) {
        return 0;
    }
    return (effectiveTimeSavedSeconds / maxTimeSavedSeconds) * 100;
}

function secondsToHms(d) {
    const timeInSecondes = Number(d);
    const timeInHours = Math.floor(timeInSecondes / 3600);
    const timeInMinutes = Math.floor((timeInSecondes % 3600) / 60);
    return LocaleService.t('TRANSACTION_PROGRESSION.TIME_SAVED_DISPLAYED', {
        hours: `0${timeInHours}`.slice(-2),
        minutes: `0${timeInMinutes}`.slice(-2),
    });
}

const TransactionProgression = ({ savedTime }) => {
    const wrapperClass = ['TransactionProgression--wrapper'];
    if (savedTime !== 0) {
        wrapperClass.push('sr-text');
    }
    return (
        <div className={wrapperClass.join(' ')}>
            <div className="TransactionProgression--details">
                <div className="TransactionProgression--title sr-text is-bold">
                    {LocaleService.t('TRANSACTION_PROGRESSION.MY_PROGRESSION')}
                </div>
                <TransactionProgressBar percentage={getpercentageProgression(savedTime, MAX_TIME)} />
                <TransactionTimeSaved
                    lowOpacity={savedTime === 0}
                    effectiveTimeSavedSeconds={secondsToHms(savedTime)}
                />
            </div>
            <div className="TransactionProgression--uptime">
                <p className="sr-text">
                    <icon className="icon-stopwatch" />&nbsp;
                    {LocaleService.t('TRANSACTION_PROGRESSION.MAX_TIME_SAVED_IN_DEALERSHIP', {
                        time: secondsToHms(MAX_TIME),
                    })}
                </p>
            </div>
        </div>
    );
};

TransactionProgression.propTypes = {
    savedTime: PropTypes.number.isRequired,
};

TransactionProgression.displayName = 'TransactionProgression';

export default TransactionProgression;
